export default "__VITE_ASSET__B4F4Bjij__"